import {useMemo} from "react";
import {useDeck} from "../../../../deck-management/context/DeckContext";
import {useLemmaLookup} from "./useLemmaLookup";
import {useCreateWordFromLookup} from "./useCreateWordFromLookup";

export const useWordAddView = () => {

    const {currentDeck} = useDeck();
    const language = currentDeck?.language ?? "";

    const {
        lemma,
        setLemma,
        searchedLemma,
        lookupResults,
        selectedIndex,
        setSelectedIndex,
        search,
        isLookingUp,
        notFound,
        reset: resetLookup,
    } = useLemmaLookup({language: language});

    const {createWord, isCreatingWord} = useCreateWordFromLookup({deckId: currentDeck?.deckId});

    const selectedResult = useMemo(
        () => (lookupResults && selectedIndex !== null) ? lookupResults[selectedIndex] : null,
        [lookupResults, selectedIndex]
    );

    const reset = () => {
        resetLookup();
    };

    return {
        lemma,
        setLemma,
        searchedLemma,
        lookupResults,
        selectedIndex,
        setSelectedIndex,
        search,
        isLookingUp,
        notFound,
        selectedResult,
        createWord,
        isCreatingWord,
        reset,
    };
};
